import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
    return (
        <footer className="main-footer bg-section">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-12">

                        <div className="footer-header">

                            <div className="section-title">
                                <h2 className="wow fadeInUp" data-cursor="-opaque">Join our newsletter for news, trends, and <span>smart solutions</span>.</h2>
                            </div>

                            <div className="contact-us-circle">
                                <Link to="/contact"><img src="/assets/images/contact-us-circle.svg" alt="" /></Link>
                            </div>

                        </div>

                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-md-12">

                        <div className="about-footer">

                            <div className="footer-logo">
                                <img src="/assets/logo/innosutra_light-v2.1.png" alt="" />
                            </div>

                            <div className="about-footer-content">
                                <p>Thane Maharashtra, India. </p>
                                {/* <p>Ana Avanta Garde, E-213 , Nr. Kashimira Police Station, Miraroad Thane, Thane 401107 Maharashtra, India. </p> */}
                            </div>

                        </div>

                    </div>

                    <div className="col-lg-8">

                        <div className="footer-links-box">
                            <div className="footer-links quick-links">
                                <h3>quick links</h3>
                                <ul>
                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="/about">About us</Link></li>
                                    <li><Link to="/refund">Refund Policy</Link></li>
                                    <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                    <li><Link to="/grievance-redressal-policy">Grievance Redressal Policy</Link></li>
                                    <li><Link to="/terms-condition">Terms & Conditions</Link></li>
                                    {/* <li><Link to="/projects">Our Projects</Link></li> */}
                                    <li><Link to="/contact-us">Contact us</Link></li>
                                    {/* <li><Link to="/contact">Contact us</Link></li> */}
                                </ul>
                            </div>

                            <div className="footer-links service-links">
                                <h3>Services</h3>
                                <ul>
                                    <li><Link to="service-single.html">AI Model Development</Link></li>
                                    <li><Link to="service-single.html">AI-Powered Chatbots</Link></li>
                                    <li><Link to="service-single.html">Mobile App Development</Link></li>
                                    <li><Link to="service-single.html">Web Development</Link></li>
                                </ul>
                            </div>

                            <div className="footer-links footer-contact-links">
                                <h3>Contact Information</h3>

                                <div className="footer-contact-item">
                                    <div className="icon-box">
                                        <img src="/assets/images/icon-phone-white.svg" alt="" />
                                    </div>
                                    <div className="footer-contact-content">
                                        <h3>Phone Number</h3>
                                        <p><Link to="tel:+123456789">+ (91) 9136254875 </Link></p>
                                    </div>
                                </div>

                                <div className="footer-contact-item">
                                    <div className="icon-box">
                                        <img src="/assets/images/icon-mail-white.svg" alt="" />
                                    </div>
                                    <div className="footer-contact-content">
                                        <h3>Email Address</h3>
                                        <p><Link to="mailto:innosutraailimited@gmail.com">innosutraailimited@gmail.com</Link></p>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                    <div className="col-lg-12">

                        <div className="footer-copyright">

                            <div className="footer-copyright-text">
                                <p>Copyright © 2026 All Rights Reserved.</p>
                            </div>

                            {/* <div className="footer-social-links">
                                <h3>Follow Us On Socials :</h3>
                                <ul>
                                    <li><Link to="#"><i className="fa-brands fa-pinterest-p"></i></Link></li>
                                    <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                                    <li><Link to="#"><i className="fa-brands fa-facebook-f"></i></Link></li>
                                    <li><Link to="#"><i className="fa-brands fa-instagram"></i></Link></li>
                                </ul>
                            </div> */}

                        </div>

                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
